export enum ReportStatusType {
  IN_QUEUE = "IN_QUEUE",
  PROCESSING = "PROCESSING",
  PROCESSED = "PROCESSED",
  ERROR = "ERROR",
  CANCELED = "CANCELED"
}
